export const PasswordDefinitions = {
    MIN_LENGTH: 8
}
